import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
//===--- Main
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
//===--- Forms
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
//===--- FAQs
import Accordion from 'react-bootstrap/Accordion';
//===--- Icons
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';
import { MdCardGiftcard } from "react-icons/md";
//===--- Data
import GiftCardItems from './data/giftCardItems';
import giftCardFAQs from './data/giftCardFAQs';

export default function GiftCards(props) {
  function carouselScroll(bool, classVar) {
    const carouselContainer = document.querySelector(`.${classVar} .mini-carousel-items`);
    const cards = document.querySelector(`.${classVar} .item`);
  
    if (bool) {
      if (carouselContainer.scrollLeft < carouselContainer.scrollWidth - carouselContainer.offsetWidth) {
        carouselContainer.scrollTo({
          left: carouselContainer.scrollLeft + cards.offsetWidth,
          behavior: 'smooth'
        });
      }
    } else {
      if (carouselContainer.scrollLeft > 0) {
        carouselContainer.scrollTo({
          left: carouselContainer.scrollLeft - cards.offsetWidth,
          behavior: 'smooth'
        });
      }
    }
  }
  const GiftCardQs = giftCardFAQs.map( ({title, desc}) => {
    return (
      <Row>
        <div>
          <h5><strong>Q: </strong></h5>
          <p>{title}</p>
        </div>
        <div>
          <h5><strong>A: </strong></h5>
          <p>{desc}</p>
        </div>
        <hr />
    </Row>
    )
  })
  const GiftCards = GiftCardItems.map( ({img, title, key}) => {
    return (
      <Card style={{ width: '14rem' }} className='border-0 item'>
        <a href={`#/menu/product?&item=${key}&other=true`}>
          <Card.Img variant='top' src={img} />
          <Card.Body>
            <Card.Title>{title}</Card.Title>
          </Card.Body>
        </a>
      </Card>
    )
  })
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      props.isSignedIn ? navigate('/rewards') : navigate('/account');
    }

    setValidated(true);
  };
  function ScrollTo(e) {
    const elem = document.getElementById(e);
    const rect = elem.getBoundingClientRect();
    const yPos = rect.top;


    window.scrollTo(0, yPos);
  }

  return (
  <section id='gift-cards'>
    <div className='banner'>
      <Container>
        <Col>
          <h2>Give the Gift of Bubblery!</h2>
          <p>Treat your friends and family to the ultimate drink experience with Bubblery Gift Cards.</p>
          <Button variant="outline-light" onClick={()=>(ScrollTo('purchase'))}>Purchase</Button>
        </Col>
        <MdCardGiftcard className="ico-reward" />
      </Container>
    </div>
    <div className="row-items bg-body-tertiary">
      <Container className="alt-container">
        <div id='purchase' className='head'>
        <h3>Gift Cards</h3>
        </div>
        <hr />
        <Col className='mini-carousel gift-cards'>
          <div className='mini-carousel-control-prev' onClick={()=>{carouselScroll(false, 'gift-cards')}}>
            <SlArrowLeft className='mini-carousel-control-prev-icon'/>
          </div>
          <Row className='mini-carousel-items'>
            {GiftCards}
          </Row>
          <div className='mini-carousel-control-next' onClick={()=>{carouselScroll(true, 'gift-cards')}}>
            <SlArrowRight className='mini-carousel-control-next-icon'/>
          </div>
        </Col>
      </Container>
    </div>
    <Container className="alt-container">
      <div className='head'>
        <h3>Check Gift Card Balance</h3>
      </div>
      <hr />
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className='mb-3'>
          <Form.Group as={Col} md='12' controlId='validationCustom01'>
            <FloatingLabel controlId='floatingInput' label='Enter Gift Card Number' className='mb-3'>
              <Form.Control
                required
                type='text'
                placeholder=''
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type='invalid'>Invalid gift card number</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
          <Form.Group as={Col} md='12' controlId='validationCustom02'>
            <FloatingLabel controlId='floatingInput' label='Enter Gift Card PIN' className='mb-3'>
              <Form.Control
                required
                type='text'
                placeholder=''
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type='invalid'>Invalid gift card PIN</Form.Control.Feedback>
            </FloatingLabel>
          </Form.Group>
        </Row>
        <Row className='form-submit'>
          <Form.Group className='mb-3'>
            <Button type='outline-dark submit' variant='dark'>Submit</Button>
            <Form.Check
                required
                label='Agree to terms and conditions'
                feedback='You must agree before submitting.'
                feedbackType='invalid'
              />
          </Form.Group>
        </Row>
      </Form>
  </Container>
  <Container className="alt-container">
    <div className='head'>
      <h3>General Gift Cards FAQs</h3>
    </div>
    <hr />
    <Accordion defaultActiveKey="0">
      <Accordion.Item eventKey="1" className='border-0'>
        <Accordion.Header></Accordion.Header>
        <Accordion.Body>
          <Col className='QnA'>
            {GiftCardQs}
          </Col>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  </Container>
  </section>
  );
}